export default __webpack_public_path__ + "static/backgroundMedia-6d2e85438c9de801da3e5d5534726c8a.jpg";